import { Dispatch, createContext, useContext, useReducer, useEffect, useState } from "react";
import { userReducer } from "../reducers/user";
import { authConstants } from "./constants";
import { Loader } from "rsuite";
import { menuReducer } from "../reducers/menu";
import { Perfil } from "../types/admin-usuarios/Perfil";
import { ModuloPermiso } from "../types/admin-usuarios/ModuloPermiso";
import { moduleReducer } from "../reducers/module";

interface UserState {
    authenticated: boolean;
    authenticating: boolean;
    logout?: boolean;
    loaded?: boolean;
    error?: string;
    credentials?: CredentialState;
    perfiles?: Array<Perfil>;
    currentperfil?: Perfil | null;
}

interface CredentialState{
    _id?: string; // user o agent
    fullname?: string;
    token?: string;
    idAgent?: string;
}

interface MenuState {
    loaded: boolean;
    loading: boolean;
    modulos?: ModuloPermiso[];
    error?: string;
}

// interface ModuleState {
//     loaded: boolean;
//     error?: string;
//     module?: ModuloPermiso;
// }

interface StoreState {
    user: UserState;
    menu: MenuState;
    module?: ModuloPermiso;
}

interface Action {
    type: string;
    payload: any;
}

const initialContextValue = {
    user: {
        authenticated: false,
        authenticating: false,
        loaded: false
    },
    menu: {
        loaded: false,
        loading: false
    },
    module: undefined

}

const Store = createContext<{
    state: StoreState;
    dispatch: Dispatch<any>;
}>({
    state: initialContextValue,
    dispatch: () => null
});

export const useStore = () : {
    state: StoreState;
    dispatch: Dispatch<any>;
} => {
    const store = useContext(Store);
    if(!store){
        throw new Error("useStore must be used within a StoreProvider")
    }
    return store;
}

const mainReducer = ({ user, menu, module }: StoreState, action: any) => ({
    user: userReducer(user, action),
    menu: menuReducer(menu, action),
    module: moduleReducer(module, action),
});

function StoreProvider({ children }: { children: React.ReactNode }) {
    const [state, dispatch] = useReducer(mainReducer, initialContextValue);
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        if(typeof window !== "undefined"){
            const localSt = localStorage.getItem("persistma") || "";
            if(localSt !== ""){
                const persist = JSON.parse(localSt);
                if(persist && persist.authenticated){
                    dispatch({
                        type: authConstants.RESTORE,
                        payload: persist
                    });
                }
            }
            setLoading(false);
        }
    }, []);

    useEffect(()=>{
        localStorage.setItem("persistma", JSON.stringify(state.user));
        if(state.user.authenticated)sessionStorage.setItem("tksk", state.user.credentials.token);
        else sessionStorage.removeItem("tksk");
    }, [state.user]);

    return (
        <>
            {
                loading ?
                <Loader center vertical content="" /> :
                <Store.Provider value={{ state, dispatch }}>
                    {children}
                    </Store.Provider>
            }
        </>

    )

}

export { initialContextValue, StoreProvider }

export type { StoreState, Action, UserState, MenuState, CredentialState }